import { memo } from 'react';

// Components
import { Image } from '@/components/Image/Image';

type Props = {
  productImage: string;
  productName: string;
};

const ProductImage = memo(({ productImage, productName }: Props) => (
  <Image
    alt={`Symbolbild für das Produkt ${productName}.`}
    className="product-image"
    src={productImage}
  />
));

ProductImage.displayName = 'ProductImage';

export { ProductImage };
